import React, { useState } from "react";

import { BasicIconButton } from "@gaming/xds-react-js";
import { Label } from "@gaming/xds-react-js-icons";

import { useProgramFillColorPicker } from "../../helpers/useProgramColorPicker";
import { useStrings } from "../../localization/localizationHelpers";
import * as styles from "./ClipboardTextBox.module.css";

interface PartnerCenterBoxWidgetRowItem {
  title: string;
  labelText: string;
}

export const ClipboardTextBox = ({ title, labelText }: PartnerCenterBoxWidgetRowItem) => {
  const [copied, copyToClipboard] = useStrings("copied", "copyToClipboard");
  const [copyMessage, setCopyMessage] = useState("");
  const onButtonClick = () => {
    navigator.clipboard.writeText(labelText);
    setCopyMessage(copied);
    setTimeout(() => setCopyMessage(""), 6000);
  };
  const colorStyle = useProgramFillColorPicker();
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{title}</h3>
      <BasicIconButton
        icon={Label}
        iconClassName={colorStyle}
        as="button"
        className={styles.textBar}
        onClick={onButtonClick}
        aria-label={`${labelText},${copyToClipboard},${title}`}
      >
        {labelText}
      </BasicIconButton>
      <div className={styles.copyLabelWrapper}>
        <span className={styles.copyLabel} aria-live="polite">
          {copyMessage}
        </span>
      </div>
    </div>
  );
};
